import { createRoute, redirect } from '@tanstack/react-router';

import { hasPermissionFactory } from '$/components/core/Authentication/hooks/useAuthorization';
import { useAuthenticationStore } from '$/components/core/Authentication/stores/useAuthenticationStore';
import { SchoolPage } from '$/pages/SchoolPage';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';

export const SchoolRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/school',
  component: SchoolPage,
  beforeLoad: () => {
    const { user } = useAuthenticationStore.getState();

    if (!hasPermissionFactory(user?.role)('School_See_Profile')) {
      redirect({ to: '/not-allowed', throw: true });
    }
  },
});
